import styled from 'foundations-theming/utils';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTBody = styled.tbody.withConfig({
  displayName: "TableBody__StyledTBody",
  componentId: "sc-1aq1xo4-0"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
export const TableBody = props => {
  const {
    domProps,
    callbackProps,
    tokenProps,
    restProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTBody, Object.assign({}, domProps, callbackProps, restProps, {
    $cssStyles: cssStyles
  }));
};